export enum IconType {
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  BurgerMenu = 'burger-menu',
  Calendar = 'calendar',
  Checkmark = 'checkmark',
  CheckmarkBubble = 'checkmark-bubble',
  ChevronUpThick = 'chevron-up-thick',
  ChevronDownThick = 'chevron-down-thick',
  ChevronDown = 'chevron-down',
  ChevronRightThick = 'chevron-right-thick',
  Clock = 'clock',
  Cross = 'cross',
  ExclamationCircle = 'exclamation-circle',
  ExclamationTriangle = 'exclamation-triangle',
  Information = 'information',
  Loading = 'loading',
  PositionIndicator = 'position-indicator',
  ExclamationMark = 'exclamation-mark-circled',
  Check = 'check-circled',
  Download = 'download',
  QRCode = 'qr-code',
  Overview = 'overview',
  Shop = 'shop',
  Question = 'question',
  Support = 'support',
  User = 'user',
  Envelope = 'envelope',
  Phone = 'phone',
  Orders = 'orders',
  ProfileUser = 'profile-user',
  Logout = 'logout',
}
